import { FormControl, InputLabel, makeStyles, MenuItem, Select } from '@material-ui/core';
import clsx from 'clsx';
import { NoneArrow } from '../constants/StyleConstants';

const useStyles = makeStyles(theme => ({
  formControl: props => ({
    marginTop: 8,
    marginBottom: 4,
    minWidth: 120,
    width: props.variableWidth ? props.variableWidth : 300,
  }),
  overflow: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: 200,
  },
  stretch: {
    maxWidth: 'fit-content',
  },
  icon: {
    color: 'red',
    border: '1px solid blue',
  },
}));

const SelectAcerBrag = ({ value, setValue, selectTitle, readOnly, rows, stretch, variableWidth, forceMenuPosition = false }) => {
  const classes = useStyles({ variableWidth: variableWidth === true ? 'fit-content' : variableWidth });

  return (
    <FormControl className={classes.formControl}>
      <InputLabel id="select-state-label">{selectTitle}</InputLabel>
      <Select
        IconComponent={readOnly ? NoneArrow : undefined}
        className={clsx({ icon: classes.icon, [classes.overflow]: !readOnly, [classes.stretch]: stretch })}
        inputProps={{ readOnly: readOnly }}
        margin="dense"
        labelId="select-state-label"
        id="state-select"
        value={value}
        onChange={e => setValue(e.target.value)}
        MenuProps={forceMenuPosition ? {
          anchorOrigin:{
            vertical: 'bottom',
            horizontal: 'left',
          },
          transformOrigin:{
            vertical: 'top',
            horizontal: 'left'
          },
          getContentAnchorEl: null,
        } : undefined
      }
        >
        {rows &&
          rows.map((element, index) => (
            <MenuItem key={index} value={element.id}>
              {element.name}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
};

export default SelectAcerBrag;
